import { SetLayout } from "../../shared";
import dynamic from "next/dynamic";

const Skeleton = dynamic(() => import("react-loading-skeleton"), {
    ssr: false,
});

export const SetHomeSkeleton = () => {
    return (
        <SetLayout>
            <div className="relative flex flex-col w-full h-screen">
                <div className="flex flex-col items-center justify-center w-full h-full">
                    <div className="flex flex-col items-center justify-center text-center">
                        <Skeleton
                            width={"189px"}
                            height={"65px"}
                            className="mb-2 "
                        />
                        <Skeleton width={"189px"} height={"24px"} />
                        <Skeleton
                            width={"189px"}
                            height={"24px"}
                            className="mb-2 "
                        />
                    </div>
                </div>
            </div>
            <div className="fixed bottom-0 z-10 px-4 pb-4 mt-auto w-i">
                <Skeleton height={"56px"} width={"100%"} />
            </div>
        </SetLayout>
    );
};
